var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchNoInfoSecondary = function SvgSearchNoInfoSecondary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#FFF2EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4474 67.552L60.9786 55.0833C59.413 57.4062 57.4099 59.4103 55.0859 60.976L67.5547 73.4447C69.1818 75.0718 71.8203 75.0718 73.4474 73.4447C75.0724 71.8228 75.0724 69.177 73.4474 67.552Z",
    fill: "#FF7E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.9069 21.3333C31.034 21.3333 21.334 31.0343 21.334 42.9999C21.334 54.9655 31.034 64.6666 42.9069 64.6666C54.7798 64.6666 64.5736 54.9655 64.5736 42.9999C64.5736 31.0343 54.9694 21.3333 42.9069 21.3333ZM42.9069 56.3333C35.5548 56.3333 29.5736 50.352 29.5736 42.9999C29.5736 35.6478 35.5548 29.6666 42.9069 29.6666C50.259 29.6666 56.2403 35.6478 56.2403 42.9999C56.2403 50.3541 50.3548 56.3333 42.9069 56.3333Z",
    fill: "#FF7E51"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchNoInfoSecondary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-no-info-secondary.5dd7047f.svg";
export { ForwardRef as ReactComponent };